import { Toaster } from 'sonner';

/**
 * The panel's toasts (Sonner): bottom right on a computer, above the phone
 * bar on the phone, stacked three deep and swiped away. Colors, type and
 * radius come from the look in styles/motion.css.
 */
export function Toasts() {
  return (
    <Toaster
      className="dale-toaster"
      position="bottom-right"
      offset={24}
      mobileOffset={{ bottom: 104, left: 12, right: 12 }}
      gap={10}
      visibleToasts={3}
      duration={3200}
      theme="light"
      toastOptions={{ className: 'dale-toast' }}
    />
  );
}
